<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        รายงานตารางรายการส่งเสริมการขายที่เสนอขายในตลาด (โปรวินาทีต้องไม่น้อยกว่า 50%)
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <!-- <i class="fa fa-dashboard"></i> รายงานจำนวนรายการส่งเสริมการขายบริการโทรศัพท์เคลื่อนที่จำแนกตามประเภทบริการ -->
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="150px"
                      :model="form"
                      ref="ruleForm"
                      class="demo-ruleForm"
                    >
                      <div class="col-sm-12">
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="col-sm-6">
                              <el-form-item label="ประเภทรายงาน" required>
                                <el-select
                                  ref="type_report"
                                  v-model="form.type_report"
                                  @change="clear_data"
                                >
                                  <el-option label="รายเดือน" value="month"></el-option>
                                  <el-option label="ระหว่างเดือน" value="between_month"></el-option>
                                  <el-option label="รายปี" value="year"></el-option>
                                  <el-option label="ระหว่างปี" value="between_year"></el-option>
                                  <el-option label="ไตรมาส" value="quarter"></el-option>
                                  <el-option label="ช่วงไตรมาส" value="between_quarter"></el-option>
                                </el-select>
                              </el-form-item>
                            </div>
                            <div class="col-sm-6">
                              <el-form-item
                                label="กรุณาเลือกประเภทรายงาน"
                                v-if="form.type_report === ''"
                              >
                                <el-input disabled placeholder></el-input>
                              </el-form-item>
                              <el-form-item
                                label="ช่วงเวลา"
                                default-value="2556"
                                v-bind:class="[form.type_report === 'month' ?  '': 'not_display']"
                                required
                              >
                                <el-date-picker
                                  ref="month"
                                  v-model="form.type_data.month"
                                  style="width:100%;"
                                  :default-value="defaultDate"
                                  type="month"
                                  clearable
                                ></el-date-picker>
                              </el-form-item>
                              <el-form-item
                                label="ช่วงเวลา"
                                v-bind:class="[form.type_report === 'between_month' ?  '': 'not_display']"
                                required
                              >
                                <el-date-picker
                                  ref="monthfrom"
                                  :default-value="defaultDate"
                                  v-model="form.type_data.monthfrom"
                                  style="width:40%;"
                                  type="month"
                                  clearable
                                ></el-date-picker>&nbsp;-&nbsp;
                                <el-date-picker
                                  ref="monthto"
                                  :default-value="defaultDate"
                                  v-model="form.type_data.monthto"
                                  style="width:40%;"
                                  type="month"
                                  clearable
                                ></el-date-picker>
                              </el-form-item>
                              <el-form-item
                                label="ช่วงเวลา"
                                v-bind:class="[form.type_report === 'year' ?  '': 'not_display']"
                                required
                              >
                                <el-date-picker
                                  ref="year"
                                  v-model="form.type_data.year"
                                  style="width:100%;"
                                  type="year"
                                  :default-value="defaultDate"
                                  clearable
                                ></el-date-picker>
                              </el-form-item>
                              <el-form-item
                                label="ช่วงเวลา"
                                v-bind:class="[form.type_report === 'between_year' ?  '': 'not_display']"
                                required
                              >
                                <el-date-picker
                                  :default-value="defaultDate"
                                  ref="yearfrom"
                                  v-model="form.type_data.yearfrom"
                                  type="year"
                                ></el-date-picker>&nbsp;&nbsp;-&nbsp;
                                <el-date-picker
                                  :default-value="defaultDate"
                                  ref="yearto"
                                  v-model="form.type_data.yearto"
                                  type="year"
                                ></el-date-picker>
                              </el-form-item>
                              <el-form-item
                                label="ช่วงเวลา"
                                v-bind:class="[form.type_report === 'quarter' ?  '': 'not_display']"
                                required
                              >
                                <el-select
                                  style="width:50%;"
                                  ref="quarter"
                                  v-model="form.type_data.quarter"
                                >
                                  <el-option label="1" value="1"></el-option>
                                  <el-option label="2" value="2"></el-option>
                                  <el-option label="3" value="3"></el-option>
                                  <el-option label="4" value="4"></el-option>
                                </el-select>&nbsp;
                                <el-date-picker
                                  :default-value="defaultDate"
                                  v-model="form.type_data.quarter_year"
                                  ref="quarter_year"
                                  type="year"
                                ></el-date-picker>
                              </el-form-item>
                              <el-form-item
                                label="ช่วงเวลา"
                                v-if="form.type_report === 'between_quarter'"
                                v-bind:class="[form.type_report === 'between_quarter' ?  '': 'not_display']"
                                required
                              >
                                <el-select
                                  style="width:20%;"
                                  ref="quarterfrom"
                                  v-model="form.type_data.quarterfrom"
                                >
                                  <el-option label="1" value="1"></el-option>
                                  <el-option label="2" value="2"></el-option>
                                  <el-option label="3" value="3"></el-option>
                                  <el-option label="4" value="4"></el-option>
                                </el-select>&nbsp;
                                <el-date-picker
                                  style="width:25%;"
                                  v-model="form.type_data.quarter_year_from"
                                  :default-value="defaultDate"
                                  ref="quarter_year_from"
                                  type="year"
                                ></el-date-picker>&nbsp;&nbsp;-&nbsp;
                                <el-select
                                  style="width:20%;"
                                  ref="quarterto"
                                  v-model="form.type_data.quarterto">
                                  <el-option label="1" value="1"></el-option>
                                  <el-option label="2" value="2"></el-option>
                                  <el-option label="3" value="3"></el-option>
                                  <el-option label="4" value="4"></el-option>
                                </el-select>&nbsp;
                                <el-date-picker
                                  v-model="form.type_data.quarter_year"
                                  :default-value="defaultDate"
                                  ref="quarter_year"
                                  type="year"
                                  style="width:25%;"
                                ></el-date-picker>
                              </el-form-item>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="col-sm-12">
                              <el-form-item label="ประเภทผู้ให้บริการ">
                                <el-radio-group v-model="form.compare_type" @change="compareType">
                                  <el-radio label="group">กลุ่มผู้ให้บริการ</el-radio>
                                  <el-radio label="provider">รายชื่อผู้ให้บริการ</el-radio>
                                </el-radio-group>
                              </el-form-item>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="col-sm-12">
                              <el-form-item label="กลุ่มผู้ให้บริการ" :required="form.compare_type == 'group'">
                                <el-checkbox-group v-model="form.provider_group" :disabled="this.form.compare_type !== 'group'">
                                  <el-checkbox 
                                  ref="provider_group"
                                    v-for="group in this.store_groups" 
                                    :key="group.id" 
                                    :label="group.id">
                                    {{group.group_name_th}}
                                  </el-checkbox>
                                </el-checkbox-group>
                              </el-form-item>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="col-sm-12">
                              <el-form-item label="รายชื่อผู้ให้บริการ" :required="form.compare_type == 'provider'">
                                <el-checkbox-group v-model="form.provider_list" :disabled="this.form.compare_type !== 'provider'">
                                  <el-checkbox 
                                  ref="provider_list"
                                    v-for="provider in this.store_providers" 
                                    :key="provider.id" 
                                    :label="provider.id">
                                    {{provider.brand_name}}
                                  </el-checkbox>
                                </el-checkbox-group>
                              </el-form-item>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="col-sm-6">
                              <el-form-item label="ย่านความถี่" required>
                                <el-checkbox-group v-model="form.frequency">
                                  <el-checkbox label="900">900 MHz</el-checkbox>
                                  <el-checkbox label="1800">1800 MHz</el-checkbox>
                                  <el-checkbox label="2100">2.1 GHz</el-checkbox>
                                  <el-checkbox label="other">อื่น ๆ</el-checkbox>
                                </el-checkbox-group>
                              </el-form-item>
                            </div>
                            <div class="col-sm-6">
                              <el-form-item label="การจำแนกข้อมูล">
                                <el-radio-group v-model="form.type_data.classify">
                                  <el-radio :label="1">จำแนกตามผู้ให้บริการ</el-radio>
                                  <el-radio :label="0">ไม่จำแนกผู้ให้บริการ</el-radio>
                                </el-radio-group>
                              </el-form-item>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="col-sm-12">
                              <el-form-item label="สถานะการให้บริการ">
                                <el-checkbox-group v-model="form.service_status">
                                    <el-checkbox label="S">ประเภทบุคคลทั่วไป (รายการส่งเสริมการขายที่ยังขายอยู่)</el-checkbox><br/>
                                    <el-checkbox label="U">ประเภทบุคคลทั่วไป (รายการส่งเสริมการขายที่ไม่ขายแล้ว แต่ยังให้บริการอยู่)</el-checkbox><br/>
                                    <el-checkbox label="CS">ประเภทองค์กร (รายการส่งเสริมการขายที่ยังขายอยู่)</el-checkbox><br/>
                                    <el-checkbox label="CU">ประเภทองค์กร (รายการส่งเสริมการขายที่ไม่ขายแล้ว แต่ยังให้บริการอยู่)</el-checkbox><br/>
                                </el-checkbox-group>
                              </el-form-item>
                            </div>
                          </div>
                        </div>
                        <div class="layout_filter_btn">
                          <button type="button" class="btn btn-primary" @click="generate()">ค้นหา</button>
                        </div>
                      </div>
                    </el-form>
                  </div>
                  <div class="box-body" v-if="showDataNotFound">
                    <div class="col-sm-12">
                      <h4 align="center">ไม่พบข้อมูลการค้นหา</h4>
                    </div>
                  </div>
                  <div class="box-body" style="min-height: 500px;" v-if="!showDataNotFound">
                    <div class="col-sm-12">
                      <div class="row" v-bind:class="[ showTable === false ?  '': 'not_display']">
                        <div
                          class="col-sm-12"
                          style="width:100%;text-align:right;padding-bottom:20px"
                        >
                          <div class="col-sm-12" style="text-align:right;">
                            <el-dropdown @command="exportFile" style="padding-right:7.2%">
                              <span class="btn btn-primary" >
                                Export<i class="el-icon-arrow-down el-icon--right"></i>
                              </span>
                              <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item icon="el-icon-download" command="pdf">Export PDF</el-dropdown-item>
                                <el-dropdown-item icon="el-icon-download" command="doc">Export DOC</el-dropdown-item>
                                <el-dropdown-item icon="el-icon-download" command="xls">Export XLS</el-dropdown-item>
                              </el-dropdown-menu>
                            </el-dropdown>
                          </div>
                        </div>
                        <div class="col-sm-1"></div>
                        <div class="col-sm-10" ref="bar_providers" id="data2">
                          <div class="col-sm-12" align="center">
                            <label v-html="text_label"></label>
                          </div>
                          <table border="1" style="width:100%;border-collapse: collapse;border: 1px solid black;text-align:center; max-width: 1000px; margin-left: auto; margin-right: auto;">
                          <!-- <table border="1" style="width:100%;border-collapse: collapse;border: 1px solid black;text-align:center;"> -->
                            <tr align="center">
                              <th></th>
                              <th colspan="2">จำนวนรายการส่งเสริมการขาย</th>
                              <th colspan="2">
                                ร้อยละรายการส่งเสริมการขาย
                                <br />โดยเปรียบเทียบ
                              </th>
                            </tr>
                            <tr>
                              <td align="center"></td>
                              <td align="center">วินาที</td>
                              <td align="center">นาที</td>
                              <td align="center">วินาที</td>
                              <td align="center">นาที</td>
                            </tr>
                            <tr v-for="items in data_service_providers" v-bind:key="items.id">
                              <template v-if="items.colspan === 1">
                                <td colspan="5" align="center">{{items.text}}</td>
                              </template>
                              <template v-else>
                              <td align="center">{{items.service_name}}</td>
                              <td align="center">{{items.amount_sec}}</td>
                              <td align="center">{{items.amount_min}}</td>
                              <td align="center" v-bind:style="[items.percent_sec < proportion_second ? {'color':'red'} : '']">{{items.percent_sec}}</td>
                              <td align="center">{{items.percent_min}}</td>
                              </template>
                            </tr>
                          </table>
                        </div>
                        <div class="col-sm-1"></div>
                      </div>
                      <div class="row" v-bind:class="[ showTable ?  '': 'not_display']">
                        <div
                          class="col-sm-12"
                          style="width:100%;text-align:right;padding-bottom:20px"
                        >
                          <div class="col-sm-12" style="text-align:right;">
                            <el-dropdown @command="exportFile">
                              <span class="btn btn-primary" >
                                Export<i class="el-icon-arrow-down el-icon--right"></i>
                              </span>
                              <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item icon="el-icon-download" command="pdf">Export PDF</el-dropdown-item>
                                <el-dropdown-item icon="el-icon-download" command="doc">Export DOC</el-dropdown-item>
                                <el-dropdown-item icon="el-icon-download" command="xls">Export XLS</el-dropdown-item>
                              </el-dropdown-menu>
                            </el-dropdown>
                          </div>
                        </div>
                        <div class="col-sm-1"></div>
                        <div class="col-sm-10" ref="tableData" id="data">
                           <div class="col-sm-12" align="center">
                            <label v-html="text_label"></label>
                          </div>
                          <table border="1" style="width:100%;border-collapse: collapse;border: 1px solid black; max-width: 1000px; margin-left: auto; margin-right: auto;">
                          <!-- <table border="1" style="width:100%;border-collapse: collapse;border: 1px solid black;"> -->
                            <tr align="center">
                              <th rowspan="3">ลำดับที่</th>
                              
                              <th rowspan="3" v-if="this.form.type_report === 'between_quarter'">ไตรมาส</th>
                              <th rowspan="3" v-else>เดือน</th>
                              <th colspan="6">
                                จำนวนรายการส่งเสริมการขายที่เสนอขายในตลาด
                                <br />(โปรวินาทีต้องไม่น้อยกว่า {{proportion_second}}%)
                              </th>
                            </tr>
                            <tr align="center">
                              <th colspan="2">โปรวินาที</th>
                              <th colspan="2">โปรนาที</th>
                              <th colspan="2">รวม</th>
                            </tr>
                            <tr align="center">
                              <th align="center">จำนวน</th>
                              <th align="center">%</th>
                              <th align="center">จำนวน</th>
                              <th align="center">%</th>
                              <th align="center">จำนวน</th>
                              <th align="center">%</th>
                            </tr>
                            <!-- เริ่มลูป -->
                            <tr v-for="items in data_table" v-bind:key="items.id">
                              <template v-if="items.colspan === 1">
                                <td colspan="8" align="center">{{items.text}}</td>
                              </template>
                              <template v-else>
                                <td >{{items.rank}}</td>
                                <td >{{items.month}}</td>
                                <td >{{items.v_point}}</td>
                                <td  v-bind:style="[items.v_per < proportion_second ? {'color':'red'} : '']">{{items.v_per}}</td>
                                <td >{{items.min_point}}</td>
                                <td >{{items.min_per}}</td>
                                <td >{{items.all_point}}</td>
                                <td >{{items.all_per}}</td>
                              </template>
                            </tr>
                            <!-- // ปิดลูป -->
                          </table>
                        </div>
                        <div class="col-sm-1"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>
<script src="es6-promise.auto.min.js"></script>
<script src="jspdf.min.js"></script>
<script src="html2canvas.min.js"></script>
<script src="html2pdf.min.js"></script>
<script>
import { mapState, mapActions } from "vuex";
import moment  from "moment";
import utility from "../../lib/utility";
import jsPDF from "jspdf";
export default {
  data() {
    return {
      defaultDate: "",
      show: false,
      label_position: "top",
      form: {
        type_data: {
          classify: 1,
          quarter: "",
          year: "",
          month: "",
          monthfrom: "",
          monthto: "",
          quarter_year: "",
          quarter_year_from: "",
          quarterfrom: "",
          quarterto: "",
          yearfrom: "",
          yearto: ""
        },
        frequency: ['900','1800','2100'],
        service_status: ['S','U','CS','CU'],
        checkList: [],
        type_report: "",
        year: "",
        quarter: "",
        provider_group: [],
        provider_list: [],
        compare_type: "group",
      },
      pending : false
    };
  },
  beforeCreate(){
    this.$store.dispatch('Report_G5/getGroupCompany','mobile')
    this.$store.dispatch('Report_G5/getProviderByType','mobile')
    this.$store.dispatch('Report_G5/resetTable')
  },
  computed: {
    ...mapState({
      store_groups : store => store.Report_G5.provider_group,
      store_providers : store => store.Report_G5.provider_list,
      text_label:store => store.Report_G5.text_label,
      data_service_providers: store => store.Report_G5.data_service_providers,
      showTable: store => store.Report_G5.showTable,
      data_table: store => store.Report_G5.data_table,
      proportion_second: store => store.Report_G5.proportion_second,
      showDataNotFound: store => store.Report_G5.showDataNotFound
    })
  },
  beforeUpdate() {},
  created() {},
  methods: {
    ...mapActions({
      searching : 'Report_G5/setData'
    }),
    clear_data() {
      this.form.type_data = {
        classify: this.form.type_data.classify,
        monthfrom: "",
        monthto: "",
        quarter: "",
        quarter_year: "",
        quarter_year_from: "",
        year: "",
        month: "",
        quarterfrom: "",
        quarterto: "",
        yearfrom: "",
        yearto: ""
      };
    },
    generatePDF(dname) {
      var doc = new jsPDF('landscape');
      doc.internal.scaleFactor = 1.8;
      this.$html2canvas(this.$refs[dname], { canvas: null }).then(function(canvas) {
        const img = canvas.toDataURL("image/png",1.0);
        doc.addImage(img, "JPEG", 10, 10, 280, 200);
        doc.save("Report.pdf");
      });
    },
    generate(){
      if(this.form.type_report === ""){
        this.$alert("กรุณาเลือกประเภทรายงาน", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.type_report.focus();
          }
        });
      }else if( this.form.type_report === "month" && this.form.type_data.month === ""){
        this.$alert("กรุณาเลือกเดือน", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.month.focus();
          }
        });
      }else if(this.form.type_report === "between_month" && (this.form.type_data.monthfrom === "" || this.form.type_data.monthto === "")){
        this.$alert("กรุณาเลือกระหว่างเดือน", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            if (this.form.type_data.monthfrom.length == 0) {
              this.$refs.monthfrom.focus();
            } else {
              this.$refs.monthto.focus();
            }
          }
        });
      }else if(this.form.type_report === "year" && this.form.type_data.year === "") {
        this.$alert("กรุณาเลือกปี", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.year.focus();
          }
        });
      }else if(this.form.type_report === "between_year" && (this.form.type_data.yearfrom.length === 0 ||this.form.type_data.yearto.length === 0)) {
        this.$alert("กรุณาเลือกระหว่างปี", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            if (this.form.type_data.yearfrom.length == 0) {
              this.$refs.yearfrom.focus();
            } else {
              this.$refs.yearto.focus();
            }
          }
        });
      }else if(this.form.type_report === "quarter" &&(this.form.type_data.quarter === "" ||this.form.type_data.quarter_year.length === 0)) {
        this.$alert("กรุณาเลือกไตรมาส", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.quarter.focus();
            if (this.form.type_data.quarter.length == 0) {
              this.$refs.quarter.focus();
            } else {
              this.$refs.quarter_year.focus();
            }
          }
        });
      }else if(this.form.type_report === "between_quarter" &&
            (this.form.type_data.quarterfrom.length === 0 ||
            this.form.type_data.quarterto.length === 0 ||
            this.form.type_data.quarter_year_from.length === 0 ||
            this.form.type_data.quarter_year.length === 0)) {
          this.$alert("กรุณาเลือกช่วงไตรมาส", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            if (this.form.type_data.quarterfrom.length === 0) {
              this.$refs.quarterfrom.focus();
            }else if (this.form.type_data.quarter_year_from.length === 0){
              this.$refs.quarter_year_from.focus();
            }else if (this.form.type_data.quarterto.length === 0) {
              this.$refs.quarterto.focus();
            }else if (this.form.type_data.quarter_year.length === 0){
              this.$refs.quarter_year.focus();
            }
          }
        });
      }else if(this.form.provider_group.length < 1 && this.form.provider_list.length < 1 && this.form.compare_type == ""){
        this.$alert("กรุณาประเภทการเปรียบเทียบ", "แจ้งเตือน", { confirmButtonText: "ตกลง"});
      }else if(this.form.compare_type == "group" && this.form.provider_group.length === 0 ){
        this.$alert("กรุณาเลือกกลุ่มผู้ให้บริการ", "แจ้งเตือน", { confirmButtonText: "ตกลง"});
      }else if(this.form.compare_type == "provider" && this.form.provider_list.length === 0){
        this.$alert("กรุณาเลือกรายชื่อผู้ให้บริการ", "แจ้งเตือน", { confirmButtonText: "ตกลง"});
      }else if (this.form.service_status === "") {
        this.$alert('กรุณาเลือกประเภทข้อมูล', 'แจ้งเตือน', {
            confirmButtonText: 'ตกลง',
            callback: action => {
                this.$refs.service_status.focus()
            }
        })
      }
      else{
        this.show = true
        let formdata = this.form
            formdata.list = this.form.compare_type == "group" ? this.store_groups.filter(item => this.form.provider_group.includes(item.id)) : this.store_providers.filter(item => this.form.provider_list.includes(item.id))
        this.searching(formdata)
      }
    },
    compareType(){
      
        this.form.provider_list = []
        this.form.provider_group = []
    },
    exportFile(com){
     if(this.form.type_data.classify == 0){
      if(com=="pdf"){
        this.$html2canvas(this.$refs.tableData, { canvas: null }).then(function(canvas) {
          const img = canvas.toDataURL("image/png", 1.0);
          var doc = new jsPDF("p","mm");
          var imgWidth = 210; 
          var pageHeight = 295;  
          var imgHeight = canvas.height * imgWidth / canvas.width;
          var heightLeft = imgHeight
          var position = 0;

          doc.addImage(img, 'PNG', 0, 5, imgWidth, imgHeight);
          heightLeft -= pageHeight;
          while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            doc.addPage();
            doc.addImage(img, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
          }
          doc.save("Report5.pdf");
        });
      }else if(com=="doc"){
        var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' "+
                    "xmlns:w='urn:schemas-microsoft-com:office:word' "+
                    "xmlns='http://www.w3.org/TR/REC-html40'>"+
                    "<head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body>";
        var footer = "</body></html>";
        let clone = document.getElementById("data").cloneNode(true)
        clone.children[1].style.maxWidth = 'none'
        var sourceHTML = header+clone.innerHTML+footer;
        var source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
        var fileDownload = document.createElement("a");
        document.body.appendChild(fileDownload);
        fileDownload.href = source;
        fileDownload.download = 'Report.doc';
        fileDownload.click();
        document.body.removeChild(fileDownload);
      }else if(com=="xls"){
        var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' "+
                    "xmlns:w='urn:schemas-microsoft-com:office:word' "+
                    "xmlns='http://www.w3.org/TR/REC-html40'>"+
                    "<head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body>";
        var footer = "</body></html>";
        var sourceHTML = header+document.getElementById("data").innerHTML+footer;
        var source = 'data:application/vnd.ms-excel;charset=utf-8,' + encodeURIComponent(sourceHTML);
        var fileDownload = document.createElement("a");
        document.body.appendChild(fileDownload);
        fileDownload.href = source;
        fileDownload.download = 'Report.xls';
        fileDownload.click();
        document.body.removeChild(fileDownload);
      }
     }
     else if(this.form.type_data.classify == 1){
       if(com=="pdf"){
         this.$html2canvas(this.$refs.bar_providers, { canvas: null }).then(function(canvas) {
          const img = canvas.toDataURL("image/png", 1.0);
          var doc = new jsPDF("p","mm");
          var imgWidth = 210; 
          var pageHeight = 295;  
          var imgHeight = canvas.height * imgWidth / canvas.width;
          var heightLeft = imgHeight
          var position = 0;

          doc.addImage(img, 'PNG', 0, 5, imgWidth, imgHeight);
          heightLeft -= pageHeight;
          while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            doc.addPage();
            doc.addImage(img, 'PNG', 0, position+3, imgWidth, imgHeight);
            heightLeft -= pageHeight;
          }
          doc.save("Report5.pdf");
        });
      }else if(com=="doc"){
        var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' "+
                    "xmlns:w='urn:schemas-microsoft-com:office:word' "+
                    "xmlns='http://www.w3.org/TR/REC-html40'>"+
                    "<head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body>";
        var footer = "</body></html>";
        let clone = document.getElementById("data2").cloneNode(true)
        clone.children[1].style.maxWidth = 'none'
        var sourceHTML = header+clone.innerHTML+footer;
        var source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
        var fileDownload = document.createElement("a");
        document.body.appendChild(fileDownload);
        fileDownload.href = source;
        fileDownload.download = 'Report.doc';
        fileDownload.click();
        document.body.removeChild(fileDownload);
      }else if(com=="xls"){
        var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' "+
                    "xmlns:w='urn:schemas-microsoft-com:office:word' "+
                    "xmlns='http://www.w3.org/TR/REC-html40'>"+
                    "<head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body>";
        var footer = "</body></html>";
        var sourceHTML = header+document.getElementById("data2").innerHTML+footer;
        var source = 'data:application/vnd.ms-excel;charset=utf-8,' + encodeURIComponent(sourceHTML);
        var fileDownload = document.createElement("a");
        document.body.appendChild(fileDownload);
        fileDownload.href = source;
        fileDownload.download = 'Report.xls';
        fileDownload.click();
        document.body.removeChild(fileDownload);
      }
     }
    },
  }
};
</script>
<style>
table,
td,
th {
  /* border: 1px solid black; */
}

table {
  /* border-collapse: collapse; */
  width: 100%;
}
table tr th {
  text-align: center;
  height: 55px;
}
th,
tr {
  height: 30px;
  text-align: center;
  width: 150px !important;
}
.color-red {
  color: red !important;
}
.color-green {
  color: green !important;
}
</style>
